export default {
	nbRowText: '0 paiement |1 paiement | {count} paiements',
	cancel: 'RETOUR',
	success: 'Le paiement a bien été ajouté',
	btnExport: 'Exporter',
	btnDownloadReceipts: 'Générer Justificatif',
	btnApproveAll: 'Tout approuver',
	btnConfirm: {
		all: 'Aucun paiement sélectionné | Approuver le paiement | Approuver les {count} paiements',
		partial: 'Aucune décision sélectionnée | Appliquer les décisions sur le paiement | Appliquer les décisions sur les {count} paiements'
	},

	paymentRejectionDetailsDialog: {
		title: 'Détails du rejet',
		closeButton: 'J\'ai compris',
		informationMessage: 'Pour connaitre la démarche à suivre pour traiter ce rejet, rendez-vous sur le ',
		helpCenterLabel: 'centre d\'aide',
		helpCenterUrl: 'https://plateforme-article51.zendesk.com/hc/fr/articles/34943852149266-Que-faire-si-mon-paiement-a-%C3%A9t%C3%A9-rejet%C3%A9',
		rejectionReasonLabel: 'Motif du rejet',
		rejectionCommentLabel: 'Commentaire'
	},

	selectedPayments:
		'Aucun paiement sélectionné | 1 paiement sélectionné | {count} paiements sélectionnés',

	headerTooltip:
		'Pour un dépôt entre le 7 juin et le 5 juillet 2021, la période de facturation correspond à "Juin 2021 (07/06 - 06/07)".',

	action: {
		approve: {
			label: 'Approuver',
			dialog: {
				title: 'Êtes-vous sûr de vouloir approuver ce paiement ? | Êtes-vous sûr de vouloir approuver ces {count} paiements ?'
			}
		},
		approve_dgos: {
			label: 'Envoyer à DGOS',
			dialog: {
				title: 'Êtes-vous sûr de vouloir envoyer ce paiement ? | Êtes-vous sûr de vouloir envoyer ces {count} paiements ?',
				subTitle: 'Veuillez indiquer la date de transmission pour ce paiement : | Veuillez indiquer la date de transmission pour les {count} paiements :',
				additionalData: {
					type: 'date',
					name: 'sendingDate'
				}
			}
		},
		unapprove: {
			label: 'Passer en non approuvé',
			dialog: {
				title: 'Êtes-vous sûr de vouloir passer ce paiement en non approuvé ? | Êtes-vous sûr de vouloir passer ces paiements en non approuvé ?'
			}
		},
		unapprove_dgos: {
			label: 'Passer en non approuvé',
			dialog: {
				title: 'Êtes-vous sûr de vouloir passer ce paiement en non approuvé ? | Êtes-vous sûr de vouloir passer ces paiements en non approuvé ?'
			}
		},
		refuse: {
			label: 'Refuser',
			dialog: {
				title: 'Êtes-vous sûr de vouloir refuser ce paiement ? | Êtes-vous sûr de vouloir refuser ces paiements ?'
			}
		},
		unlock: {
			label: 'Débloquer',
			dialog: {
				title: 'Êtes-vous sûr de vouloir débloquer ce paiement ? | Êtes-vous sûr de vouloir débloquer ces paiements ?'
			}
		},
		pay: {
			label: 'Paiement effectué | Paiements effectués',
			dialog: {
				title: 'Liquidation d’un paiement | Liquidation des paiements',
				subTitle: 'Veuillez indiquer la date de mandatement pour ce paiement : | Veuillez indiquer la date de mandatement pour les {count} paiements :',
				additionalData: {
					type: 'date',
					name: 'orderDate'
				}
			}
		},
		reject: {
			label: 'Rejeter le paiement | Rejeter les paiements',
			dialog: {
				title: 'Êtes-vous sûr de vouloir rejeter ce paiement ? | Êtes-vous sûr de vouloir rejeter ces paiements ?'
			}
		},
		recycle: {
			label: 'Recycler le paiement | Recycler les paiements',
			dialog: {
				title: 'Êtes-vous sûr de vouloir recycler ce paiement ? | Êtes-vous sûr de vouloir recycler ces paiements ?',
				paymentDebit: 'Ce paiement a une reprise sur flux | Ces paiements ont une reprise sur flux.',
				confirmPaymentDebit: 'Voulez-vous valider cette reprise sur flux ? | Voulez-vous valider ces reprises sur flux ?',
				confirmWithPaymentDebitBtn: 'Recycler le paiement en conservant la reprise sur flux | Recycler les paiements en conservant la reprise sur flux',
				confirmWithoutPaymentDebitBtn: 'Recycler le paiement sans conserver la reprise sur flux | Recycler les paiements sans conserver la reprise sur flux',
				headers: [
					{
						text: 'Projet',
						value: 'project'
					},
					{
						text: 'Destinataire de versement',
						value: 'actor'
					},
					{
						text: 'Montant',
						value: 'amount'
					},
					{
						text: 'Montant de reprise',
						value: 'paymentDebit'
					},
					{
						text: 'Solde à payer',
						value: 'balance'
					}
				]
			}
		},
		recycle_dgos: {
			label: 'Recycler le paiement | Recycler les paiements',
			dialog: {
				title: 'Êtes-vous sûr de vouloir recycler ce paiement ? | Êtes-vous sûr de vouloir recycler ces paiements ?'
			}
		},
		cancel: {
			label: 'Annuler le paiement | Annuler les paiements',
			dialog: {
				title: 'Êtes-vous sûr de vouloir annuler ce paiement ? | Êtes-vous sûr de vouloir annuler ces paiements ?'
			}
		},
		cancel_dgos: {
			label: 'Annuler le paiement | Annuler les paiements',
			dialog: {
				title: 'Êtes-vous sûr de vouloir annuler ce paiement ? | Êtes-vous sûr de vouloir annuler ces paiements ?'
			}
		},
		delete: {
			label: 'Supprimer le paiement | Supprimer les paiements',
			dialog: {
				title: 'Êtes-vous sûr de vouloir supprimer ce paiement ? | Êtes-vous sûr de vouloir supprimer ces paiements ?'
			}
		},
		revalidate: {
			label: 'Revalider | Revalider les paiements',
			dialog: {
				title: 'Êtes-vous sûr de vouloir revalider ce paiement ? | Êtes-vous sûr de vouloir revalider ces paiements ?'
			}
		},
		export: {
			label: 'Exporter'
		},
		approveAll: {
			label: 'Tout approuver',
			dialog: {
				title: 'Êtes-vous sûr.e de vouloir approuver {paymentsCount} paiements ?',
				subTitle: 'Les paiments au statut "En attente" ne sont pas pris en compte.'
			}
		},
		waiting: {
			label: 'Mettre en attente',
			dialog: {
				title: 'Êtes-vous sûr de vouloir passer ce paiement en attente ? | Êtes-vous sûr de vouloir passer ces paiements en attente ?'
			}
		},
		approve_with_payment_debit: {
			label: 'Approuver',
			dialog: {
				title: 'Êtes-vous sûr de vouloir passer ce paiement en à reprendre ? | Êtes-vous sûr de vouloir passer ces paiements en à reprendre ?'
			}
		},
		recover: {
			label: 'Reprendre',
			dialog: {
				title: 'Êtes-vous sûr de vouloir passer ce paiement en repris ? | Êtes-vous sûr de vouloir passer ces paiements en repris ?',
				subTitle: 'Veuillez indiquer la date de mandatement pour ce paiement : | Veuillez indiquer la date de mandatement pour les {count} paiements :',
				additionalData: {
					type: 'date',
					name: 'orderDate'
				}
			}
		},
		cancel_with_payment_debit: {
			label: 'Annuler',
			dialog: {
				title: 'Êtes-vous sûr de vouloir annuler la reprise sur flux pour ce paiement ? | Êtes-vous sûr de vouloir annuler la reprise sur flux pour ces paiements ?'
			}
		},
		generateReceipt: 'Générer un justificatif',
		generateReceiptError: 'Une erreur est survenue lors de la génération du justificatif de paiement.'
	},

	successMessage:
		'Le changement de statut a été effectué avec succès | Les changements de statut ont été effectués avec succès',
	warningMessage:
		'Le paiement ci-dessous nécessite une vérification de votre part car il dépasse le budget de son groupement. | Les {paymentsCount} paiements ci-dessous nécessitent une vérification de votre part car ils dépassent le budget de leur groupement.',
	warningMessageWithUndue:
		'Le paiement ci-dessous nécessite une vérification de votre part car il est lié à un indu non soldé. | Les {paymentsCount} paiements ci-dessous nécessitent une vérification de votre part car ils sont liés à un indu non soldé.',
	amount_debit: 'Des paiements sont déjà en cours de reprise pour cet acteur sur ce projet pour un total de reprise de {reprise}.',
	allow_debit: 'Il existe au moins un indu de cet acteur sur le projet qui n\'autorise pas la reprise sur flux',
	status: [
		{
			value: 'to_pay',
			text: 'À payer'
		},
		{
			value: 'paid',
			text: 'Payé'
		},
		{
			value: 'to_approve',
			text: 'À approuver'
		},
		{
			value: 'not_approved',
			text: 'Non approuvé'
		},
		{
			value: 'rejected',
			text: 'Rejeté'
		},
		{
			value: 'to_recycle',
			text: 'À recycler'
		},
		{
			value: 'waiting',
			text: 'En attente'
		},
		{
			value: 'to_approve',
			text: 'À transférer DGOS'
		},
		{
			value: 'transferred_dgos',
			text: 'Transféré DGOS'
		},
		{
			value: 'rejected',
			text: 'Annulé'
		},
		{
			value: 'to_recover',
			text: 'À reprendre'
		},
		{
			value: 'recovered',
			text: 'Repris'
		}
	]
};
